import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getTrialLicenses() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_trial_Licenses'
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/trialLicenses.js